import { Button, Grid, TextField } from '@mui/material'
import { isEqual } from 'lodash'
import { memo } from 'react'
import { metodoPrograma } from '../../../components/api'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

const retornaLocalAtendimento = (u = []) => ({
  idAlimentoGrupo: u?.[0] || undefined,
  dsNome: u?.[1] || '',
  dtExclusao: u?.[2] || '',
})

const createAgenda = z.object({
  idAlimentoGrupo: z.number().optional(),
  dsNome: z.string().min(3, {
    message: 'Nome inválido',
  }),
})

const Edicao = ({ dados, voltar }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(createAgenda),
    defaultValues: retornaLocalAtendimento(dados),
  })

  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) voltar()
  }

  return (
    <form onSubmit={handleSubmit(salva)}>
      <Grid container spacing={2}>
        <Grid item xs={10}>
          <TextField
            {...register('dsNome')}
            label="Nome"
            fullWidth
            margin="dense"
            variant="outlined"
            error={!!errors.dsNome}
            helperText={errors.dsNome?.message}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            {...register('dtExclusao')}
            label="Data de Exclusão"
            fullWidth
            margin="dense"
            variant="outlined"
            disabled
            error={!!errors.dtExclusao}
            helperText={errors.dtExclusao?.message}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{ display: 'flex', flexDirection: 'row-reverse' }}
        >
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ margin: '5px' }}
          >
            Salvar
          </Button>
          <Button
            onClick={voltar}
            variant="contained"
            color="secondary"
            style={{ margin: '5px' }}
          >
            Cancelar
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default memo(Edicao, isEqual)
